export default __webpack_public_path__ + "static/media/desktop-feature-3.b179aab5.png";